<script>
import Multiselect from 'vue-multiselect'
import Isotope from 'isotope-layout';
import Packery from 'isotope-packery';
import _ from 'lodash';

export default {
    name: 'accommodation',

    components: {
        Multiselect
    },

    props: {
        accommodation_packages: Array,
        accommodation_prices: Array,
        accommodation_berths: Array,
        accommodation_features: Array,
    },

    data: function() {
        return {
            isotope: null,
            num_results: 0,
            packages: [],
            features: [],
            prices:   [],
            berths:   [],
            search: null,
        };
    },


    mounted: function() {
        let self = this;

        self.isotope = new Isotope('.accommodation-results', {
            layoutMode: 'packery',
            itemSelector: '.accommodation-results-item'
        });


        window.onresize = function () {
            self.redrawIsotope();
        };


        let image_loader = null;
        let images = this.$el.getElementsByTagName('img');
		for (let i = 0; i < images.length; i++) {
			images[i].addEventListener('load', function() {
				if (image_loader) clearTimeout(image_loader);

				image_loader = setTimeout(function() {
					self.redrawIsotope();
				}, 300);
			});
		}
    },


    beforeDestroy() {
        if (this.isotope) {
            this.isotope.destroy();
        }
    },


    created: function () {
        this.setInitialFilters();

        this.packages    = this.accommodation_packages;
        this.features    = this.accommodation_features;
        this.prices      = this.accommodation_prices;
        this.berths      = this.accommodation_berths;
        this.num_results = this.accommodation_packages.length;

        _.forEach(this.packages, function (pack) {
            pack.is_visible = true;
        });
    },



    watch: {
        search: {
            deep: true,
            handler(new_search, old_search) {
                this.filterPackages();
            }
        },
    },


    methods: {
        redrawIsotope: function() {
            let self = this;
            if (self.isotope) {
                self.$nextTick(function() {
                    self.isotope.arrange();
                });
            }
        },


        setInitialFilters: function() {
            this.search = {
                query: '',
                price: '',
                berth: '',
                features: [],
            };
        },


        hasFilters: function() {
            return _.some(this.search, function(filter) {
                if (_.isObject(filter) && _.get(filter, 'value')) {
                    return filter.value;
                } else {
                    return filter.length > 0;
                }
            });
        },


        clearFilters: function() {
            this.setInitialFilters();
            this.redrawIsotope();
        },


        isPackageVisible: function(package_id) {
            return _.some(this.packages, function(pack) {
                return pack.is_visible && pack.ID == package_id;
            });
        },


        filterPackages: function() {
            let _self = this;
            let num_results = 0;

            _.forEach(this.packages, function(pack) {
                let query_matches    = _self.queryMatches(pack);
                let price_matches    = _self.priceMatches(pack);
                let berth_matches    = _self.berthMatches(pack);
                let features_matches = _self.featuresMatches(pack);

                //console.log(query_matches, price_matches, berth_matches, features_matches);
                if (query_matches && price_matches && berth_matches && features_matches) {
                    pack.is_visible = true;
                    num_results++;
                } else {
                    pack.is_visible = false;
                }
            });

            // Optimisation to only have to filter once
            this.num_results = num_results;
            this.redrawIsotope();
        },


        queryMatches: function(pack) {
            if (!this.search.query) return true;


            let query = this.search.query.toLowerCase();

            if (pack.post_title.toLowerCase().includes(query)) {
                return true;
            }
            if (pack.post_excerpt.toLowerCase().includes(query)) {
                return true;
            }

            return false;
        },


        priceMatches: function(pack) {
            if (!this.search.price) {
                return true;
            }

            let price_parts = this.search.price.value.split(':');
            let min_price = price_parts[0];
            let max_price = price_parts[1];

            return _.find(pack.accomm_options, function(option) {
                let price = parseFloat(option.price);

                return min_price < price && max_price > price;
            });
        },


        berthMatches: function(pack) {
            if (!this.search.berth) {
                return true;
            }

            let selected_berth = parseInt(this.search.berth.value);

            return _.find(pack.accomm_options, function(option) {
                return parseInt(option.berth) === selected_berth;
            });
        },


        featuresMatches: function(pack) {
            return _.every(this.search.features, function(selected_feature) {
                return _.has(pack, ['features', selected_feature.value]);
            });
        }


    },
};
</script>